import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

function getTodayISO() {
  return new Date().toISOString().slice(0, 10);
}

export default function MarkExpensePendingModal({ open, expense, onClose, onSubmit }) {
  const [dueDate, setDueDate] = React.useState(getTodayISO());
  const [error, setError] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setDueDate(expense?.dueDate || getTodayISO());
      setError('');
      setSubmitting(false);
    }
  }, [open, expense]);

  const handleSubmit = async () => {
    if (!dueDate) {
      setError('Vade tarihi gerekli.');
      return;
    }

    try {
      setSubmitting(true);
      await onSubmit?.({ dueDate });
      onClose?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Gideri bekleyene al</DialogTitle>

      <DialogContent>
        <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Gider"
              value={expense?.title || 'Gider'}
              size="small"
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="date"
              label="Vade tarihi"
              value={dueDate}
              onChange={(e) => {
                setDueDate(e.target.value);
                setError('');
              }}
              size="small"
              error={!!error}
              helperText={error}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Vazgeç
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
